import React from 'react';
import Reflux from 'reflux';
import PopoverMenu from 'shared/components/menus/popoverMenu.jsx';
import { OrderedMap, Map } from 'immutable';
import CuesheetStore from 'shared/flux/stores/cuesheet/CuesheetStore';
import PopoverStore from 'shared/flux/stores/PopoverStore';
import PopoverActions from 'shared/flux/actions/PopoverActions';
import PureRenderMixin from 'react-pure-render/mixin';
import ColumnMenuMixin from 'main/components/show/cuesheet/columnHeaderCell/columnMenuMixin';
import GridColumnMenuHelper from 'main/components/show/grid/columnHeaderCell/columnMenuHelper';
import keyIn from 'shared/lib/immutable/keyIn';
import role from 'shared/lib/role';

export default React.createClass({
  displayName: 'ColumnMenu',

  mixins: [
    Reflux.connect(PopoverStore, 'popoverVisibility'),
    PureRenderMixin,
    ColumnMenuMixin,
    Reflux.connectFilter(CuesheetStore, 'userSettings', (st) =>
      st.get('userSettings'),
    ),
    Reflux.connectFilter(CuesheetStore, 'showSettings', (st) => {
      if (!st.get('show')) return null;
      return st
        .get('show')
        .filter(
          keyIn(
            'displayType',
            'displayItemNumbers',
            'displayStartTime',
            'displayDuration',
            'displayPresetDuration',
            'displayItemTitles',
            'displayItemDescriptions',
          ),
        );
    }),
  ],

  propTypes: {
    user: React.PropTypes.object,
    additionalItems: React.PropTypes.object,
  },

  getDefaultProps() {
    return {
      additionalItems: OrderedMap(),
    };
  },

  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  render() {
    const { teamId, eventId } = this.context.router.state.params;

    if (!this.state.showSettings) return null;

    const hasEventAdmin = role.hasEventAdminRole(
      this.props.user,
      teamId,
      eventId,
    );

    if (!hasEventAdmin) return null;

    const showMenu = this.state.popoverVisibility.get(this._getColumnId());

    return (
      <PopoverMenu
        grid
        className="grid-utility-column-menu"
        config={this._getConfigData()}
        show={showMenu}
      />
    );
  },

  _getConfigData() {
    const id = this._getColumnId();

    const addDivider = this.props.additionalItems.size ? true : false;

    const items = GridColumnMenuHelper.getUtilityColumnOptions(
      this.context,
      this.state,
      addDivider,
      this.props.user,
    ).concat(this.props.additionalItems);

    return Map({
      id,
      noCaret: false,
      icon: 'angle-down',
      placement: 'bottom',
      onClick: () => PopoverActions.show(id),
      onHide: () => PopoverActions.hide(id),
      items,
    });
  },

  _getColumnId() {
    return `util-column-${this.props.id}`;
  },
});
